import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentJob: null,
  targetJob: null,
  profilePhoto: null,
  currentJobDescription: null,
  targetJobDescription: null,
  targetJobID: null,
  occupationId: null,
  quizCompleted: false,
  totalScore: 0,
  proficiencyLevel: "",
  hasPathway: false,
  preferredFormatLearning: [],
  supportRequired: [],
  hasAIJobImpact: false,
  skillsGapCount: 0,
  skillsGap: [],
  // User profile data
  firstName: null,
  lastName: null,
  profileImage: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      if (action.payload.currentJob !== undefined) {
        state.currentJob = action.payload.currentJob;
      }
      if (action.payload.targetJob !== undefined) {
        state.targetJob = action.payload.targetJob;
      }
      if (action.payload.profilePhoto !== undefined) {
        state.profilePhoto = action.payload.profilePhoto;
      }
      if (action.payload.currentJobDescription !== undefined) {
        state.currentJobDescription = action.payload.currentJobDescription;
      }
      if (action.payload.targetJobDescription !== undefined) {
        state.targetJobDescription = action.payload.targetJobDescription;
      }
      if (action.payload.targetJobID !== undefined) {
        state.targetJobID = action.payload.targetJobID;
      }
      if (action.payload.quizCompleted !== undefined) {
        state.quizCompleted = action.payload.quizCompleted;
      }
      if (action.payload.totalScore !== undefined) {
        state.totalScore = action.payload.totalScore;
      }
      if (action.payload.proficiencyLevel !== undefined) {
        state.proficiencyLevel = action.payload.proficiencyLevel;
      }
      if (action.payload.hasPathway !== undefined) {
        state.hasPathway = action.payload.hasPathway;
      }
      if (action.payload.preferredFormatLearning !== undefined) {
        state.preferredFormatLearning = action.payload.preferredFormatLearning;
      }
      if (action.payload.supportRequired !== undefined) {
        state.supportRequired = action.payload.supportRequired;
      }
      if (action.payload.hasAIJobImpact !== undefined) {
        state.hasAIJobImpact = action.payload.hasAIJobImpact;
      }
      if (action.payload.occupationId !== undefined) {
        state.occupationId = action.payload.occupationId;
      }
      if (action.payload.skillsGapCount !== undefined) {
        state.skillsGapCount = action.payload.skillsGapCount;
      }
      if (action.payload.skillsGap !== undefined) {
        state.skillsGap = action.payload.skillsGap;
      }
      // Extract profile data
      if (action.payload.firstName !== undefined) {
        state.firstName = action.payload.firstName;
      }
      if (action.payload.lastName !== undefined) {
        state.lastName = action.payload.lastName;
      }
      if (action.payload.profileImage !== undefined) {
        state.profileImage = action.payload.profileImage;
      }
    },
    setCurrentJob: (state, action) => {
      state.currentJob = action.payload;
    },
    setTargetJob: (state, action) => {
      state.targetJob = action.payload;
    },
    setCurrentJobDescription: (state, action) => {
      state.currentJobDescription = action.payload;
    },
    setTargetJobDescription: (state, action) => {
      state.targetJobDescription = action.payload;
    },
    setTargetJobID: (state, action) => {
      state.targetJobID = action.payload;
    },
    setQuizCompleted: (state, action) => {
      state.quizCompleted = action.payload;
    },
    setTotalScore: (state, action) => {
      state.totalScore = action.payload;
    },
    setProficiencyLevel: (state, action) => {
      state.proficiencyLevel = action.payload;
    },
    setPreferredFormatLearning: (state, action) => {
      state.preferredFormatLearning = action.payload;
    },
    setSupportRequired: (state, action) => {
      state.supportRequired = action.payload;
    },
    setHasPathway: (state, action) => {
      state.hasPathway = action.payload;
    },
    setHasAIJobImpact: (state, action) => {
      state.hasAIJobImpact = action.payload;
    },
    setSkillsGapCount: (state, action) => {
      state.skillsGapCount = action.payload;
    },
    setSkillsGap: (state, action) => {
      state.skillsGap = action.payload;
    },
    clearUser: (state) => {
      return initialState;
    },
  },
});

export const {
  setUser,
  setCurrentJob,
  setTargetJob,
  clearUser,
  setCurrentJobDescription,
  setTargetJobDescription,
  setTargetJobID,
  setQuizCompleted,
  setTotalScore,
  setProficiencyLevel,
  setHasPathway,
  setPreferredFormatLearning,
  setSupportRequired,
  setHasAIJobImpact,
  setSkillsGapCount,
  setSkillsGap,
} = userSlice.actions;
export default userSlice.reducer;
